/* unplugin-vue-components disabled */import script from "./OrderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderView.vue?vue&type=script&setup=true&lang=ts"

import "./OrderView.vue?vue&type=style&index=0&id=2e3c1751&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3c1751"]])

export default __exports__